import { render } from "./LastProduct.vue?vue&type=template&id=e3d1ef96&scoped=true"
import script from "./LastProduct.vue?vue&type=script&lang=js"
export * from "./LastProduct.vue?vue&type=script&lang=js"

import "./LastProduct.vue?vue&type=style&index=0&id=e3d1ef96&lang=scss&scoped=true"
import "./LastProduct.vue?vue&type=style&index=1&id=e3d1ef96&lang=css"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3d1ef96"]])

export default __exports__